import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ContextService } from '@bcef/ia-shared';
import { Observable } from 'rxjs';

import { ProductListResponse } from '@features/termination/interfaces';

@Injectable({
  providedIn: 'root',
})
export class ProductListService {
  private readonly http: HttpClient = inject(HttpClient);

  private readonly contextService: ContextService = inject(ContextService);

  public getProductList(): Observable<ProductListResponse> {
    const typo = this.contextService.isHbGroup ? '-hb' : '';
    return this.http.get<ProductListResponse>(`/apps/ia-resil-contrats/product-list${typo}.json`);
  }
}
